import useSendBoardEvent, {
  BoardTransitionEvent,
  MachineGroup,
} from "../../../utils/hooks/commonly-stored/uploaded-board/state-machine/sendBoardEvent";
import LoadingOverlay from "../../LoadingOverlay";
import Button from "../../common/Button";
import { Board } from "../../../reducers/uploadedBoard";
import { useCustomAlert } from "../../../utils/hooks/alerts";
import { useBoardFromContext } from "../../../utils/hooks/commonly-stored/uploaded-board/board";

export default function ReprocessPhysicalDetails() {
  const board = useBoardFromContext().board as Board;
  const customAlert = useCustomAlert();
  const errorHandler = () => {
    customAlert("Failed to reprocess");
  };
  const { sendBoardEvent, loading: sendingBoardEvent } =
    useSendBoardEvent(errorHandler);

  const reprocess = () => {
    void sendBoardEvent(board.id, {
      machine_group: MachineGroup.BOARD,
      model_id: board.id,
      event: BoardTransitionEvent.SHOULD_REPROCESS_PHYSICAL_DETAILS,
    });
  };

  return (
    <>
      <LoadingOverlay
        loading={sendingBoardEvent}
        text={"Starting processing..."}
      />
      <Button label={"Reprocess physical details"} onClick={reprocess} />
    </>
  );
}
